const common = require('./common.json');
const billing = require('./billing.json');
const places = require('./places.json');
const roles = require('./roles.json');
const errors = require('./errors.json');

module.exports = Object.assign(common, billing, places, roles, errors);
